import Founders from "../components/Founders";

export default function Home() {
  return (
    <>
      {/* Hero Section */}
      <section className="relative overflow-hidden pt-16 md:pt-24 pb-20 px-gutter max-w-container-max mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center relative z-10">
          <div className="space-y-6">
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-secondary-container text-on-secondary-container rounded-full">
              <img src="/cafe-logo.webp" alt="CAFE" className="h-5 w-5 object-contain" />
              <span className="font-label-bold text-label-bold uppercase">Modern Agri-Tech</span>
            </div>
            <h1 className="font-headline-xl text-headline-xl text-on-background max-w-xl">
              Technology-Driven <span className="text-primary">Seed Quality</span> Solutions
            </h1>
            <p className="font-body-lg text-body-lg text-on-surface-variant max-w-md">
              Chomu Agrifood Enterprises (CAFE) optimizes crop productivity through high-accuracy cucumber seed quality assessments and scientific monitoring.
            </p>
            <div className="flex flex-wrap gap-4 pt-4">
              <button className="bg-primary text-on-primary h-12 px-8 rounded-lg font-label-bold text-label-bold shadow-sm hover:brightness-110 transition-all">
                Get Assessment
              </button>
              <button className="border-2 border-primary text-primary h-12 px-8 rounded-lg font-label-bold text-label-bold hover:bg-primary/5 transition-all">
                View Analytics
              </button>
            </div>
          </div>
          <div className="relative group">
            <div className="absolute -inset-4 bg-growth-green/10 rounded-xl blur-2xl group-hover:bg-growth-green/20 transition-all"></div>
            <div className="relative rounded-2xl overflow-hidden shadow-sm aspect-video">
              <img
                alt="Cucumber seed assessment"
                className="w-full h-full object-cover"
                src="https://lh3.googleusercontent.com/aida-public/AB6AXuCiMMB__Yrb6Tc0LL4P3OZCKCxnxAOidQw3mVuAkIGThumlOy2Dtdm1Ew0VEGR7OqR83z-qts-k2PnRlfQxBkneYLvtX_Z4hyQt15bACdgH87X00Q_1viMC4TxrSnLii3naIRG9BE1QmbSo_zelJEjZ3OIh9Q_5PHUcr6nY91cWoVR0x_1sg7rniFDFsQOlWsPMqx8NzWQ8bGDlwEs1n-KwGjykm195kcU6oou1FVjI4t_ILF5dDSLl-V1t4S-bOVMuy2ccmi5WDn4"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 glass-card p-6 rounded-xl shadow-xl border-l-4 border-growth-green hidden md:block">
              <div className="flex items-center gap-3 mb-2">
                <span className="material-symbols-outlined text-growth-green">check_circle</span>
                <span className="font-label-bold text-label-bold text-growth-green uppercase">High Quality Match</span>
              </div>
              <p className="font-label-mono text-label-mono text-on-surface-variant">BATCH VERIFIED</p>
            </div>
          </div>
        </div>
      </section>

      {/* Features Bento Grid */}
      <section className="py-20 bg-surface-container-low px-gutter">
        <div className="max-w-container-max mx-auto">
          <div className="text-center mb-16 space-y-4">
            <h2 className="font-headline-lg text-headline-lg text-on-background">Systematic Monitoring & AI</h2>
            <p className="font-body-md text-body-md text-on-surface-variant max-w-2xl mx-auto">
              We bridge biological growth with technological data to ensure reliable planting material for modern agriculture.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 auto-rows-[240px]">
            <div className="md:col-span-2 bento-item bg-white p-8 rounded-xl shadow-sm border border-outline-variant flex flex-col justify-between overflow-hidden relative">
              <div className="relative z-10">
                <span className="material-symbols-outlined text-4xl text-primary mb-4">memory</span>
                <h3 className="font-headline-md text-headline-md mb-2">AI-Driven Assessment</h3>
                <p className="font-body-md text-body-md text-on-surface-variant max-w-sm">Our proprietary algorithms analyze seed morphology and germination potential with scientific precision.</p>
              </div>
              <div className="absolute top-0 right-0 h-full w-1/2 opacity-10 bg-gradient-to-l from-primary to-transparent"></div>
            </div>
            <div className="bento-item bg-data-teal text-on-primary p-8 rounded-xl shadow-sm flex flex-col justify-between">
              <span className="material-symbols-outlined text-4xl mb-4" style={{ fontVariationSettings: "'FILL' 1" }}>query_stats</span>
              <div>
                <h3 className="font-headline-md text-headline-md mb-2">Real-time Monitoring</h3>
                <p className="font-body-sm text-body-sm opacity-80">Track development stages with automated sensor feedback.</p>
              </div>
            </div>
            <div className="bento-item bg-growth-green text-white p-8 rounded-xl shadow-sm flex flex-col justify-between">
              <span className="material-symbols-outlined text-4xl mb-4">grass</span>
              <div>
                <h3 className="font-headline-md text-headline-md mb-2">Reliable Material</h3>
                <p className="font-body-sm text-body-sm opacity-90">Reducing agricultural risk by vetting every single seed batch.</p>
              </div>
            </div>
            <div className="md:col-span-2 bento-item bg-white p-8 rounded-xl shadow-sm border border-outline-variant flex items-center gap-12 overflow-hidden">
              <div className="flex-1">
                <h3 className="font-headline-md text-headline-md mb-2">Laboratory Standards</h3>
                <p className="font-body-md text-body-md text-on-surface-variant">Validated by IIT Ropar scientific protocols for maximum accuracy.</p>
                <div className="flex gap-3 mt-6">
                  <span className="px-3 py-1 bg-surface-container rounded-full font-label-mono text-label-mono text-on-surface-variant">ISO CERTIFIED</span>
                  <span className="px-3 py-1 bg-surface-container rounded-full font-label-mono text-label-mono text-on-surface-variant">TOP GRADE</span>
                </div>
              </div>
              <div className="hidden md:flex w-1/3 aspect-square bg-seed-husk/30 rounded-full border-4 border-white shadow-inner items-center justify-center">
                <span className="material-symbols-outlined text-6xl text-primary/40">microbiology</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stakeholders Section */}
      <section className="py-24 px-gutter max-w-container-max mx-auto">
        <div className="flex flex-col md:flex-row gap-12 items-start">
          <div className="md:w-1/3 space-y-4">
            <h2 className="font-headline-lg text-headline-lg text-on-background">Empowering the Ecosystem</h2>
            <p className="font-body-md text-body-md text-on-surface-variant">From large-scale producers to small-hold farmers, our insights create value across the entire agricultural value chain.</p>
          </div>
          <div className="md:w-2/3 grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { icon: "corporate_fare", title: "Seed Companies", desc: "Optimizing batch consistency and branding with quality guarantees." },
              { icon: "potted_plant", title: "Nurseries", desc: "Improving germination rates and sapling health monitoring." },
              { icon: "agriculture", title: "Farmers", desc: "Maximizing crop yields through verified reliable planting material." },
            ].map((item) => (
              <div key={item.title} className="space-y-4 group">
                <div className="w-16 h-16 rounded-xl bg-surface-container-high flex items-center justify-center group-hover:bg-primary group-hover:text-white transition-all duration-300">
                  <span className="material-symbols-outlined text-3xl">{item.icon}</span>
                </div>
                <h4 className="font-headline-md text-headline-md">{item.title}</h4>
                <p className="font-body-sm text-body-sm text-on-surface-variant">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Founders Section */}
      <Founders />

      {/* Incubation & Support */}
      <section className="py-16 px-gutter">
        <div className="max-w-container-max mx-auto bg-on-background rounded-3xl p-12 overflow-hidden relative">
          <div className="absolute right-0 top-0 w-1/3 h-full opacity-10 pointer-events-none">
            <svg className="w-full h-full" viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
              <circle cx="200" cy="200" fill="none" r="180" stroke="white" strokeWidth="2"></circle>
              <circle cx="200" cy="200" fill="none" opacity="0.5" r="140" stroke="white" strokeWidth="1"></circle>
              <circle cx="200" cy="200" fill="none" opacity="0.2" r="100" stroke="white" strokeWidth="1"></circle>
            </svg>
          </div>
          <div className="relative z-10 flex flex-col md:flex-row items-center gap-12">
            <div className="flex-1 space-y-6">
              <h2 className="font-headline-lg text-headline-lg text-white">Supported by <span className="text-primary-fixed">AWaDH</span></h2>
              <p className="font-body-md text-body-md text-surface-container opacity-80">
                CAFE is proudly incubated and supported by iHub-AWaDH at the Indian Institute of Technology (IIT) Ropar. This partnership ensures our technology is rooted in cutting-edge agricultural research and engineering excellence.
              </p>
              <div className="flex items-center gap-6">
                <div className="bg-white/10 p-4 rounded-lg">
                  <span className="font-label-bold text-label-bold text-white uppercase tracking-widest">IIT Ropar - TIF</span>
                </div>
                <div className="h-10 w-[1px] bg-white/20"></div>
                <div className="bg-white/10 p-4 rounded-lg">
                  <span className="font-label-bold text-label-bold text-white uppercase tracking-widest">iHub-AWaDH</span>
                </div>
              </div>
            </div>
            <div className="w-full md:w-1/3 aspect-video rounded-2xl overflow-hidden bg-white p-4 flex items-center justify-center">
              <img src="/IIT-Ropar-AWaDH.webp" alt="iHub-AWaDH IIT Ropar" className="max-w-full max-h-full object-contain" />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 text-center px-gutter">
        <div className="max-w-2xl mx-auto space-y-8">
          <h2 className="font-headline-xl text-headline-xl text-on-background">Ready to optimize your harvest?</h2>
          <p className="font-body-lg text-body-lg text-on-surface-variant">Join the leading seed quality portal and start managing your agricultural batches with data-driven confidence.</p>
          <div className="flex justify-center gap-4">
            <button className="bg-primary text-on-primary h-14 px-10 rounded-lg font-label-bold text-label-bold text-lg shadow-lg hover:shadow-primary/20 transition-all">
              Register Your Batch
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
